function mobileStickyCTA() 
{
    const mobileContainer = document.querySelector('.compare-favorite-mobile');

    if (mobileContainer != null) {
        const containerPosition = mobileContainer.getBoundingClientRect().top;
        const button = mobileContainer.querySelector('.btn');
        const defaultData = button.getAttribute('data-elementplacement');

        window.addEventListener('scroll', () => {
            if (window.pageYOffset >= containerPosition) {
                mobileContainer.classList.add('mobile-sticky-active');
                button.setAttribute('data-elementplacement', 'mobile-sticky');
            }

            if (window.pageYOffset < containerPosition) {
                mobileContainer.classList.remove('mobile-sticky-active');
                button.setAttribute('data-elementplacement', defaultData);
            }
        });
    }
}

export default function init()
{
    mobileStickyCTA();
}